import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import { useLocation } from "react-router-dom";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

function Copyright() {
  return (
    <Typography sx={{ fontSize: { xs: 16, md: 19 }, color: "#FFF" }}>
      {"Copyright © "} {new Date().getFullYear()}{" "}
      <Link
        color="inherit"
        href={"https://vucaware.com/"}
        sx={{ cursor: "pointer" }}
        target="_blank"
      >
        Vucaware
      </Link>
    </Typography>
  );
}

export default function FooterComponent() {
  const location = useLocation();

  const footers = [
    { title: "Privacy Policy", link: "https://vucaware.com/privacy-policy/" },
    { title: "Terms", link: "https://vucaware.com/terms-and-conditions/" },
    {
      title: "Shipping and Delivery Policy",
      link: "https://merchant.razorpay.com/policy/LrtLSHDrUk9pC7/shipping",
    },
  ];

  const social = [
    {
      title: "Facebook",
      icon: <FacebookIcon sx={{ fontSize: 30, color: "#FFF" }} />,
      link: "https://www.facebook.com/TrueSelfy",
    },
    {
      title: "LinkedIn",
      icon: <LinkedInIcon sx={{ fontSize: 30, color: "#FFF" }} />,
      link: "https://www.linkedin.com/showcase/trueselfy/",
    },
  ];

  return (
    <Box sx={{ py: 3 }}>
      <Grid
        container
        spacing={{ xs: 2, md: 0 }}
        justifyContent="space-between"
        alignItems="center"
        sx={{
          px: { xs: 2, sm: 5, md: 5, lg: 10, xl: 15 },
        }}
      >
        {/* Left Section: Navigational Links */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
              justifyContent: { xs: "center", md: "flex-start" },
              alignItems: "center",
            }}
          >
            {footers.map((footer, index) => (
              <Link
                key={index}
                href={footer?.link}
                target="_blank"
                sx={{
                  color: "#FFF",
                  fontSize: { xs: 16, md: 19 },
                  textDecoration: "underline",
                  "&:hover": {
                    color: "#26801E",
                  },
                }}
              >
                {footer.title}
              </Link>
            ))}
            {
              <Link
                component="a"
                href="/contact-us"
                target="_blank"
                rel="noopener noreferrer"
                display={
                  location.pathname === "/contact-us" ? "none" : "inline-block"
                }
                sx={{
                  color: "#FFF",
                  fontSize: { xs: 16, md: 19 },
                  textDecoration: "underline",
                  cursor: "pointer",
                  "&:hover": {
                    color: "#26801E",
                  },
                }}
              >
                Contact us
              </Link>
            }
          </Box>
        </Grid>

        {/* Right Section: Copyright and Social Media */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 2,
              justifyContent: { xs: "center", md: "flex-end" },
              alignItems: "center",
            }}
          >
            <Copyright />
            <Box
              sx={{
                display: "flex",
                gap: 2,
              }}
            >
              {social.map((item, index) => (
                <Link
                  key={index}
                  href={item?.link}
                  target="_blank"
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#FFF",
                    "&:hover": {
                      color: "#26801E",
                    },
                  }}
                >
                  {item.icon}
                </Link>
              ))}
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Box sx={{ display: "none" }}>
        {/* Hidden SEO tags for roles */}
        <p>
          Software Engineer, Technical Architect, Data Engineer, Project
          Manager, Product Manager, DevOps Engineer, Security Specialist,
          Cybersecurity Analyst, Backend Developer, Frontend Developer, Full
          Stack Developer, QA Engineer, Test Automation Engineer, Cloud
          Engineer, Site Reliability Engineer, Infrastructure Engineer, UI/UX
          Designer, Scrum Master, IT Consultant, AI Engineer, Machine Learning
          Engineer, Database Administrator, System Analyst, Business Analyst,
          Network Engineer, IT Support Engineer
        </p>
      </Box>
    </Box>
  );
}
